'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Market = require('../enums/Market');

var _Market2 = _interopRequireDefault(_Market);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TariffResponse(domainBuilder) {
  domainBuilder.defineRpcModel('TariffResponse', function (model) {
    return model.define({
      defaults: {
        id: Number.value(null),
        name: String.value(null),
        market: _Market2.default.factory.value(null),
        description: String.value(null)
      }
    });
  });
}

exports.default = TariffResponse;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/rpc/TariffResponse.js
// module id = 1456
// module chunks = 118